/** @format */

import * as actionTypes from "./../types";
import { logger } from "@goldenbird1/ui-logger-library";
// import { logger } from "cbt-sdk";
import Router from "next/router";
import base64 from "base-64";
import { result_page_view } from "../../utils/GTMDataLayer";

export const setSearchListingPageLoading = (isLoading) => {
  return {
    type: actionTypes.GET_SEARCH_LISTING_PAGE_LOADING,
    payload: {
      isLoading: isLoading,
    },
  };
};

export const setSLPDetails = (
  totalHits,
  sellerHomeLiteViews,
  aggregates,
  categories
) => {
  return {
    type: actionTypes.GET_SEARCH_LP_DETAILS,
    payload: {
      slp_count: totalHits,
      slp_content: sellerHomeLiteViews,
      slp_facets: aggregates,
      slp_categories: categories,
    },
  };
};


	let url = `${process.env.NEXT_PUBLIC_REACT_APP_API_FACET_PRODUCT_URL}/plpv2?search=bag`;
	const uname = "search@qalara.com";
	const password = "qalara@123";
	
// 	export const getSearchData = (query, oldSearchId, callback = "") => async (dispatch) => {
// 	let urlsearch = `${process.env.NEXT_PUBLIC_REACT_APP_API_FACET_PRODUCT_URL}/plpv2?search=${query}`;
// 	let buyerId  = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
// 	let userType = localStorage.getItem("userType") || "anonymousUserId";
// 	let countryName = localStorage.getItem("countryName");
// 	let user_Id = localStorage.getItem("user_Id") || "Guest";

// 	console.log("i am called 111",query)
	
// 	// let data = {
// 	//   "segmentId": countryName,
// 	//   "instanceId": "qalara",
// 	//   "query": query,
// 	//   "appSource": "Qalara_WEB",
// 	//   "searchId": oldSearchId ? oldSearchId : null,
// 	//   "userIds": {
// 	//     [userType]: user_Id,
// 	//   },
// 	//   "state": 9,
// 	//   "page": 0,
// 	//   "pageSize": 30,
// 	//   "requestType": "DIRECT",
// 	//   "requestAttributes": "",
// 	//   "resultSize": 0
// 	// };
// 	return await fetch(urlsearch, {
// 		method: "GET",
// 		// body: JSON.stringify(data),
// 		// headers: {
// 		// 	"Content-Type": 'application/json',
// 		// 	"Authorization": "Basic " + base64.encode(uname + ":" + password),
// 		// }
		
// 		// headers: {
// 		// 	Authorization: "Bearer " + token,
// 		// 	Accept: "*/*",
// 		//   },
// 	})
// 	.then((res) => {
// 		if(res.ok){
// 			console.log("resjson",res.json())
// 			return res.json();
// 		} else {
// 			throw res;
// 		}
// 	})
// 	.then((res) => {
// 		result_page_view(query);
// 		if(res){
// 			console.log("resssssssssssssssssss============",res)
// 			let {
//         totalHits = res?.totalMatchedSize || 0,
//         products = res?.assets || [],
//         aggregates = res?.literalFacets && res?.numericalFacets ? [...res?.literalFacets, ...res?.numericalFacets] : [],
//         fixedAggregates = {},
//         searchId = res?.searchId || ""
//       } = res;
// 			if(callback){
// 				callback({
//           totalHits : totalHits,
//           products : products,
//           aggregates : aggregates,
//           fixedAggregates : fixedAggregates,
//           searchId: res?.searchId || "",
//           totalPages: res?.totalPages || 0
//         });
// 			}
// 			return dispatch(
// 	      setSLPDetails(totalHits, products, aggregates, fixedAggregates)
// 	    );
// 		} else {
// 			throw res;
// 		}
// 	})
// 	.catch((error) => {
// 		console.log('error while getting search data', error);
// 		logger('error', 'error while getting search data :'+error+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
// 		if(callback){
// 			callback({'error': error})
// 		}
// 		if(error.status === 401){
//       Router.push('/signin');
//     }
// 	});
// };
	export const getSearchData = (query, oldSearchId, callback = "") => async (dispatch) => {
	let urlsearch = `${process.env.NEXT_PUBLIC_REACT_APP_API_FACET_PRODUCT_URL}/plpv2?search=${query}&size=300&from=0`;
	let buyerId  = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
	let userType = localStorage.getItem("userType") || "anonymousUserId";
	let countryName = localStorage.getItem("countryName");
	let user_Id = localStorage.getItem("user_Id") || "Guest";

	
	return await fetch(urlsearch, {
		method: "GET",
		
	})
	.then((res) => {
		if(res.ok){			
			return res.json();
		} else {
			throw res;
		}
	})
	.then((res) => {
		result_page_view(query);
		if(res){
			// let prdName=res?.products.filter(product => product.productName);
			// if(res?.products[0].productName){
			// }
			let {
        totalHits = res?.totalMatchedSize || 0,
        products = res?.assets || [],
        aggregates = res?.literalFacets && res?.numericalFacets ? [...res?.literalFacets, ...res?.numericalFacets] : [],
        fixedAggregates = {},
        searchId = res?.searchId || ""
      } = res;
			if(callback){
				callback({
          totalHits : totalHits,
          products : products,
          aggregates : aggregates,
          fixedAggregates : fixedAggregates,
          searchId: res?.searchId || "",
          totalPages: res?.totalPages || 0
        });
			}
			return dispatch(
	      setSLPDetails(totalHits, products, aggregates, fixedAggregates)
	    );
		} else {
			throw res;
		}
	})
	.catch((error) => {
		console.log('error while getting search data', error);
		logger('error', 'error while getting search data :'+error+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
		if(callback){
			callback({'error': error})
		}
		if(error.status === 401){
      Router.push('/signin');
    }
	});
};

export const getMoreData = (query, searchId, pageIndex, prevStateData = false, prevFacets, callback = "") => async(dispatch) => {
		let urlsearch = `${process.env.NEXT_PUBLIC_REACT_APP_API_FACET_PRODUCT_URL}/plpv2?search=${query}`;
	let user_Id = localStorage.getItem("user_Id") || "Guest";
	let userType = localStorage.getItem("userType") || "anonymousUserId";
	let buyerId  = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
	let data = {
		"instanceId": "qalara",
		"query": query,
		"appSource": "Qalara_WEB",
		"searchId": searchId,
		"userIds": {
		[userType] : user_Id
		},
		"state": 10,
		"pageIndex": pageIndex,
		"requestType": "PAGINATION",
		"requestAttributes": ""
	};
	return await fetch(url, {
		method: "POST",
		// body: JSON.stringify(data),
		// headers: {
		// 	"Content-Type": 'application/json',
		// 	"Authorization": "Basic " + base64.encode(uname + ":" + password),
		// }
	})
	.then((res) => {
		if(res.ok){
			if(res.status === 204){
				if(callback){
					callback({status : res.status});
				}
			} else {
				return res.json();
			}
		} else {
			throw res;
		}
	})
	.then((res) => {
		dispatch(setSearchListingPageLoading(false));
		result_page_view(query);
		if(res){
			let {
			  totalHits = res?.totalMatchedSize || 0,
			  products = res?.assets || [],
			  aggregates = res?.literalFacets && res?.numericalFacets ? [...res?.literalFacets, ...res?.numericalFacets] : prevFacets,
			  fixedAggregates = {},
			  searchId = res?.searchId || ""
			} = res;
			if (prevStateData) {
	      let newStateData = [...prevStateData, ...products];
				if(callback){
					callback({
			          totalHits : totalHits,
			          products : newStateData,
			          aggregates : aggregates,
			          fixedAggregates : fixedAggregates,
			          searchId: res?.searchId || "",
			          totalPages: res?.totalPages || 0
			        });
				}
				return dispatch(
			        setSLPDetails(totalHits, newStateData, aggregates, fixedAggregates)
			    );
		    } else {
				if(callback){
					callback({
			          totalHits : totalHits,
			          products : products,
			          aggregates : aggregates,
			          fixedAggregates : fixedAggregates,
			          searchId: res?.searchId || "",
			          totalPages: res?.totalPages || 0
			        });
				}
				return dispatch(
			        setSLPDetails(totalHits, products, aggregates, fixedAggregates)
			    );
		    }
		}
	})
	.catch((error) => {
		console.log('error while getting more search data', error);
		logger('error', 'error while getting more search data : '+error+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
		if(callback){
			callback({'error': error});
		}
		if(error.status === 401){
      Router.push('/signin');
    }
	});
}

export const getSearchFilteredData = (searchId, query, params, prevFacets, callback = "") => async(dispatch) => {
    let urlsearch = `${process.env.NEXT_PUBLIC_REACT_APP_API_FACET_PRODUCT_URL}/plpv2?search=${query}&size=300&from=0`;
    let buyerId  = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
    let data = {};
    if(params.numeric){
        data = {
          "instanceId": "qalara",
          "query": query,
          "appSource": "Qalara_WEB",
          "searchId": searchId,
          "userIds": {
            "anonymousUserId": "Guest",
            "registeredUserId": "Guest"
          },
          "state": 13,
          "page": 3,
          "requestType": "FACET",
          "requestAttributes": JSON.stringify(params),
          "sortField" : "exfactoryListPrice",
          "isSortAscending": true
        };
    } else {
        data = {
          "instanceId": "qalara",
          "query": query,
          "appSource": "Qalara_WEB",
          "searchId": searchId,
          "userIds": {
            "anonymousUserId": "Guest",
            "registeredUserId": "Guest"
          },
          "state": 13,
          "page": 3,
          "requestType": "FACET",
          "requestAttributes": JSON.stringify(params),
        };
    }
    return await fetch(urlsearch, {
        method: "GET",
        // body: JSON.stringify(data),
        // headers: {
        //  "Content-Type": 'application/json',
        //  "Authorization": "Basic " + base64.encode(uname + ":" + password),
        // }
    })
    .then((res) => {
        if(res.ok){
            return res.json();
        } else {
            throw res;
        }
    })
    .then((res) => {
        dispatch(setSearchListingPageLoading(false));
 
        let {
          totalHits = res?.totalMatchedSize || 0,
          products = res?.assets || [],
          aggregates = res?.literalFacets && res?.numericalFacets ? [...res?.literalFacets, ...res?.numericalFacets] : prevFacets,
          fixedAggregates = {},
          searchId = res?.searchId || "",
          totalPages = res?.totalPages
        } = res;
        if(callback){
            callback({
              totalHits : totalHits,
              products : products,
              aggregates : aggregates,
              fixedAggregates : fixedAggregates,
              searchId: res?.searchId || "",
              totalPages: totalPages
            });
        }
        return dispatch(
            setSLPDetails(totalHits, products, aggregates, fixedAggregates)
        );
    })
    .catch((error) => {
        console.log('error while getting search filtered data', error);
        logger('error', 'error while getting search filtered data : ' +error+': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
        if(callback){
            callback({'error': error})
        }
        if(error.status === 401){
      Router.push('/signin');
    }
    });
}

export const clearSearchFilteredData = (searchId, query, prevFacets, callback = "") => async(dispatch) => {
	let buyerId  = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
	let data = {
	  "instanceId": "qalara",
	  "query": query,
	  "appSource": "Qalara_WEB",
	  "searchId": searchId,
	  "userIds": {
	    "anonymousUserId": "Guest",
	    "registeredUserId": "Guest"
	  },
	  "state": 18,
	  "page": 0,
	  "requestType": "FACET_ALL",
	  "requestAttributes": "{\"flag\":false}"
	};
	return await fetch(url, {
		method: "POST",
		body: JSON.stringify(data),
		headers: {
			"Content-Type": 'application/json',
			"Authorization": "Basic " + base64.encode(uname + ":" + password),
		}
	})
	.then((res) => {
		if(res.ok){
			return res.json();
		} else {
			throw res;
		}
	})
	.then((res) => {
		dispatch(setSearchListingPageLoading(false));

		if(res){
			let {
			  totalHits = res?.totalMatchedSize || 0,
			  products = res?.assets || [],
			  aggregates = res?.literalFacets && res?.numericalFacets ? [...res?.literalFacets, ...res?.numericalFacets] : prevFacets,
			  fixedAggregates = {},
			  searchId = res?.searchId || ""
			} = res;
			if(callback){
				callback({
		          totalHits : totalHits,
		          products : products,
		          aggregates : aggregates,
		          fixedAggregates : fixedAggregates,
		          searchId: res?.searchId || "",
		          totalPages: res?.totalPages || 0
		        });
			}
			return dispatch(
		        setSLPDetails(totalHits, products, aggregates, fixedAggregates)
		    );
		}
	})
	.catch((error) => {
		console.log('error while clearall search data', error);
		logger('error', 'error while clearall search data : ' +error+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
		if(callback){
			callback({'error': error})
		}
		if(error.status === 401){
      Router.push('/signin');
    }
	});
}

export const clearFacetLevelSearch = (searchId, query, prevFacets, clearFacetVal, callback = "") => async(dispatch) => {
	let buyerId  = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
	let data = {
	  "instanceId": "qalara",
	  "query": query,
	  "appSource": "Qalara_WEB",
	  "searchId": searchId,
	  "userIds": {
	    "anonymousUserId": "Guest",
	    "registeredUserId": "Guest"
	  },
	  "state": 18,
	  "page": 0,
	  "requestType": "FACET",
	  "requestAttributes": JSON.stringify(clearFacetVal)
	};
	return await fetch(url, {
		method: "POST",
		body: JSON.stringify(data),
		headers: {
			"Content-Type": 'application/json',
			"Authorization": "Basic " + base64.encode(uname + ":" + password),
		}
	})
	.then((res) => {
		if(res.ok){
			return res.json();
		} else {
			throw res;
		}
	})
	.then((res) => {
		dispatch(setSearchListingPageLoading(false));

		if(res){
			let {
			  totalHits = res?.totalMatchedSize || 0,
			  products = res?.assets || [],
			  aggregates = res?.literalFacets && res?.numericalFacets ? [...res?.literalFacets, ...res?.numericalFacets] : prevFacets,
			  fixedAggregates = {},
			  searchId = res?.searchId || ""
			} = res;
			if(callback){
				callback({
		          totalHits : totalHits,
		          products : products,
		          aggregates : aggregates,
		          fixedAggregates : fixedAggregates,
		          searchId: res?.searchId || "",
		          totalPages: res?.totalPages || 0
		        });
			}
			return dispatch(
		        setSLPDetails(totalHits, products, aggregates, fixedAggregates)
		    );
		}
	})
	.catch((error) => {
		console.log('error while clear/select facetlevel search data', error);
		logger('error', 'error while clear/select facetlevel search data : ' +error+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
		if(callback){
			callback({'error': error})
		}
		if(error.status === 401){
      Router.push('/signin');
    }
	});
}

export const sortForSearch = (searchId, sortField, sortOrder, prevFacets, callback = "") => async(dispatch) => {
	let buyerId  = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
	let data = {
	  "instanceId": "qalara",
	  "searchId": searchId,
	  "appSource": "Qalara_WEB",
	  "userIds": {
	    "anonymousUserId": "Guest",
	    "registeredUserId": "Guest"
	  },
	  "state": 0,
	  "page": 0,
	  "requestType": "SORT",
	  "requestAttributes": "",
	  "resultSize": 0,
	  "pageSize" : 30,
	  "sortField" : sortField,
	  "isSortAscending": sortOrder
	};

	return await fetch(url, {
		method: "POST",
		body: JSON.stringify(data),
		headers: {
			"Content-Type": 'application/json',
			"Authorization": "Basic " + base64.encode(uname + ":" + password),
		}
	})
	.then((res) => {
		if(res.ok){
			return res.json();
		} else {
			throw res;
		}
	})
	.then((res) => {
		dispatch(setSearchListingPageLoading(false));

		if(res){
			let {
			  totalHits = res?.totalMatchedSize || 0,
			  products = res?.assets || [],
			  aggregates = res?.literalFacets && res?.numericalFacets ? [...res?.literalFacets, ...res?.numericalFacets] : prevFacets,
			  fixedAggregates = {},
			  searchId = res?.searchId || ""
			} = res;
			if(callback){
				callback({
		          totalHits : totalHits,
		          products : products,
		          aggregates : aggregates,
		          fixedAggregates : fixedAggregates,
		          searchId: res?.searchId || "",
		          totalPages: res?.totalPages || 0
		        });
			}
			return dispatch(
		        setSLPDetails(totalHits, products, aggregates, fixedAggregates)
		    );
		}
	})
	.catch((error) => {
		console.log('error while sorting facetlevel search data', error);
		logger('error', 'error while sorting facetlevel search data : ' +error+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
		if(callback){
			callback({'error': error})
		}
		if(error.status === 401){
      Router.push('/signin');
    }
	});
}

export const selectFacets = (query, facets, searchId, prevFacets, callback = "") => async (dispatch) => {
	let buyerId  = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
	let data = {
	  "instanceId": "qalara",
	  "query": query,
	  "appSource": "Qalara_WEB",
	  "searchId": searchId,
	  "userIds": {
	    "anonymousUserId": "Guest",
	    "registeredUserId": "Guest"
	  },
	  "state": 18,
	  "page": 0,
	  "requestType": "FACET_ALL",
	  "requestAttributes": "{\"flag\":true}",
	  "literalFacets": facets,
	  "numericalFacets": []
	};
	return await fetch(url, {
		method: "POST",
		body: JSON.stringify(data),
		headers: {
			"Content-Type": 'application/json',
			"Authorization": "Basic " + base64.encode(uname + ":" + password),
		}
	})
	.then((res) => {
		if(res.ok){
			return res.json();
		} else {
			throw res;
		}
	})
	.then((res) => {
		if(res){
			let {
			  totalHits = res?.totalMatchedSize || 0,
			  products = res?.assets || [],
			  aggregates = prevFacets,
			  fixedAggregates = {},
			  searchId = res?.searchId || ""
			} = res;
			if(callback){
				callback({
		          totalHits : totalHits,
		          products : products,
		          aggregates : aggregates,
		          fixedAggregates : fixedAggregates,
		          searchId: res?.searchId || "",
		          totalPages: res?.totalPages || 0
		        });
			}
			return dispatch(
		        setSLPDetails(totalHits, products, aggregates, fixedAggregates)
		    );
		}
	})
	.catch((error) => {
		console.log('error while applying filters search data', error);
		logger('error', 'error while applying filters search data : ' +error+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
		if(callback){
			callback({'error': error})
		}
		if(error.status === 401){
      Router.push('/signin');
    }
	});
}	